import { render } from "./UserHead.vue?vue&type=template&id=5966a6a5&scoped=true&ts=true"
import script from "./UserHead.vue?vue&type=script&lang=ts"
export * from "./UserHead.vue?vue&type=script&lang=ts"

import "./UserHead.vue?vue&type=style&index=0&id=5966a6a5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5966a6a5"]])

export default __exports__